// extracted by mini-css-extract-plugin
module.exports = {"container":"NoContentMessage_container___1OwH","message":"NoContentMessage_message__XrZ9A"};